module.exports = __webpack_public_path__ + "img/電気回路_6_4_2.feac7f31.png";